import React from 'react';
import styles from '../../assets/css/cards/card-footer.module.css';
import PropTypes from 'prop-types';

const CardFooter = ({ position, justified, children }) => {
    const POSITION = {
        center: styles.footer__position_center,
        right: styles.footer__position_right
    };
    const JUSTIFIED = {
        end: styles.footer__position_button
    };
    return (
        <div
            className={`${styles.footer__container} ${
                JUSTIFIED[justified] || ''
            }`}>
            <div
                className={`${styles.footer__item} ${
                    POSITION[position] || ''
                }`}>
                {/* <button>Yes, Delete</button>
                <button>Cancel</button> */}
                {children}
            </div>
        </div>
    );
};
CardFooter.propTypes = {
    children: PropTypes.node.isRequired,
    position: PropTypes.string,
    justified: PropTypes.string
};
export default CardFooter;
